import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useCurrentList = (userToken) => {
  const baseUrl = useBaseUrl();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchCurrentList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/exercise_plan/current_list`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setPlans(response.data.plans);
      } catch (error) {
        console.log("Error during current list request", error);
      }
    };

    if (userToken) {
      fetchCurrentList();
    }
  }, [baseUrl, userToken]);

  return { plans };
};
export default useCurrentList;
